import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/about-section/components/AboutInteractive.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/app/about-section/components/PageLoaderWrapper.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/ParticleBackground.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/components/common/ScrollIndicator.tsx");
